import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface FormRowProps extends HTMLAttributes<HTMLDivElement> {
  /** Number of equal-width columns at md+ breakpoints. */
  cols?: 1 | 2 | 3 | 4;
}

const colClasses: Record<NonNullable<FormRowProps['cols']>, string> = {
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
};

export function FormRow({ cols = 2, className, children, ...rest }: FormRowProps) {
  return (
    <div {...rest} className={cn('grid grid-cols-1 gap-4', colClasses[cols], className)}>
      {children}
    </div>
  );
}
